import { Link } from "react-router-dom";

export default function InformationPage() {
  return (
    <>
      <Link className="top-40" to="/">
        <div className="sticky top-5 ml-40 pt-10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="white"
            class="size-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="m11.25 9-3 3m0 0 3 3m-3-3h7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            />
          </svg>
        </div>
      </Link>
      <div className="text-white m-auto text-center mt-8 flex flex-col gap-24">
        <div className="flex flex-col gap-6">
          <h2 className=" font-semibold tracking-wide text-3xl">Kurzprofil</h2>
          <p className=" w-1/2 m-auto ">
            Als engagierter Informatiker mit fundierten Programmierkenntnissen
            und mehrjähriger Erfahrung strebe ich stets danach, meine
            Fähigkeiten weiterzuentwickeln und neue Technologien zu meistern.
            Meine Leidenschaft für das Programmieren und mein unermüdliches
            Engagement spiegeln sich in meiner Arbeit wider, wodurch ich
            kontinuierlich hochwertige und innovative Lösungen liefere.
          </p>
        </div>
        <div className="flex flex-col gap-6">
          <h2 className=" font-semibold tracking-wide text-3xl">Lebenslauf</h2>
          <a
            href="https://github.com/JuliTheProgrammer/lebenslauf/blob/main/Julian_Leipert_CV_PDF_Github.pdf"
            target="."
          >
            führe mich zu Julians Lebenslauf
          </a>
        </div>
        <div className="flex flex-col gap-6">
          <h2 className=" font-semibold tracking-wide text-3xl">
            Modulnotenüberblick
          </h2>
          <a
            href="https://github.com/JuliTheProgrammer/lebenslauf/blob/main/Modulnotenu%CC%88bersicht_Peter_Muster.pdf"
            target="."
          >
            führe mich zu Julians Modulnotenüberblick
          </a>
        </div>
      </div>
    </>
  );
}
